import { render, staticRenderFns } from "./theclassAdd.vue?vue&type=template&id=6b044b1b&scoped=true"
import script from "./theclassAdd.vue?vue&type=script&lang=js"
export * from "./theclassAdd.vue?vue&type=script&lang=js"
import style0 from "./theclassAdd.vue?vue&type=style&index=0&id=6b044b1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b044b1b",
  null
  
)

export default component.exports